/* Elaramo - Bekijk aan je eigen muur
   1) Camera (AR): het canvas op ware grootte aan je muur (iPhone: Quick Look, Android: WebXR) via <model-viewer>
   2) Muurfoto: upload een foto van je muur en schuif het canvas op zijn plek */
(function () {
  'use strict';
  var MV = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
  var GE = 'https://cdn.jsdelivr.net/npm/three@0.128.0/examples/js/exporters/GLTFExporter.js';
  var TH = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var loaded = {};
  function load(src, mod) {
    if (loaded[src]) return loaded[src];
    loaded[src] = new Promise(function (res, rej) {
      var s = document.createElement('script'); if (mod) s.type = 'module'; s.src = src; s.async = true;
      s.onload = res; s.onerror = function () { delete loaded[src]; rej(new Error('load ' + src)); };
      document.head.appendChild(s);
    });
    return loaded[src];
  }
  function ensureThree() { return window.THREE ? Promise.resolve() : load(TH); }
  function isIOS() { var a = document.createElement('a'); return !!(a.relList && a.relList.supports && a.relList.supports('ar')); }
  function arCheck() {
    if (isIOS()) return Promise.resolve(true);
    if (navigator.xr && navigator.xr.isSessionSupported) return navigator.xr.isSessionSupported('immersive-ar').catch(function () { return false; });
    return Promise.resolve(false);
  }
  function loadImg(url) {
    return new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej; i.src = url; });
  }
  function fmt(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }

  // ---------- drieluik: drie panelen met tussenruimte, elk met het eigen stuk van de foto (incl. omslag)
  function triGroup(T, c, front, side, back) {
    var g = new T.Group(), t = c.tri, d = c.d || 2, TT = c.w + 2 * d, TH = c.h + 2 * d;
    var ph = t.ph || c.h, cols = t.cols || 3, rows = t.rows || 1, W = t.pw / 100, H = ph / 100, D = d / 100;
    function U(x) { return x / TT; } function V(y) { return 1 - y / TH; }
    function plane(pw, ph, rect, m, pos, rx, ry) {
      var geo = new T.PlaneGeometry(pw, ph), uv = geo.attributes.uv;
      for (var i = 0; i < uv.count; i++) uv.setXY(i, rect[0] + uv.getX(i) * (rect[2] - rect[0]), rect[1] + uv.getY(i) * (rect[3] - rect[1]));
      uv.needsUpdate = true;
      var me = new T.Mesh(geo, m); me.position.set(pos[0], pos[1], pos[2]); me.rotation.set(rx || 0, ry || 0, 0); g.add(me);
    }
    for (var n = 0; n < cols * rows; n++) {
      var i = n % cols, r = Math.floor(n / cols);
      var x0 = d + i * (t.pw + t.gap), x1 = x0 + t.pw, y0 = d + r * (ph + t.gap), y1 = y0 + ph;
      var cx = (i - (cols - 1) / 2) * (t.pw + t.gap) / 100, cy = ((rows - 1) / 2 - r) * (ph + t.gap) / 100;
      plane(W, H, [U(x0), V(y1), U(x1), V(y0)], front, [cx, cy, D]);
      plane(W, H, [0, 0, 1, 1], back, [cx, cy, 0], 0, Math.PI);
      plane(D, H, [U(x1), V(y1), U(x1 + d), V(y0)], side, [cx + W / 2, cy, D / 2], 0, Math.PI / 2);
      plane(D, H, [U(x0 - d), V(y1), U(x0), V(y0)], side, [cx - W / 2, cy, D / 2], 0, -Math.PI / 2);
      plane(W, D, [U(x0), V(y0), U(x1), V(y0 - d)], side, [cx, cy + H / 2, D / 2], -Math.PI / 2, 0);
      plane(W, D, [U(x0), V(y1), U(x1), V(y1 + d)], side, [cx, cy - H / 2, D / 2], Math.PI / 2, 0);
    }
    return g;
  }
  function ckey(c) { return [c.url, c.w, c.h, c.d, c.tri ? c.tri.pw : 0].join('|'); }

  // ---------- 3D-model (GLB) van het canvas, zelfde opbouw als de ruimtes
  var glbCache = { key: null, url: null };
  function buildGLB(c) {
    var key = ckey(c);
    if (glbCache.key === key) return Promise.resolve(glbCache.url);
    return ensureThree().then(function () { return load(GE); }).then(function () { return loadImg(c.url); }).then(function (img) {
      var T = window.THREE, max = window.matchMedia('(pointer: coarse)').matches ? 1024 : 2048, sc = Math.min(1, max / Math.max(img.width, img.height));
      var cv = document.createElement('canvas'); cv.width = Math.round(img.width * sc); cv.height = Math.round(img.height * sc);
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      var tex = new T.CanvasTexture(cv); tex.encoding = T.sRGBEncoding;
      var W = c.w / 100, H = c.h / 100, D = (c.d || 2) / 100;
      var geo = new T.BoxGeometry(W, H, D), uv = geo.attributes.uv;
      var iar = cv.width / cv.height, car = W / H, ru = 1, rv = 1;
      if (iar > car) ru = car / iar; else if (iar < car) rv = iar / car;
      var u0 = (1 - ru) / 2, u1 = 1 - u0, v0 = (1 - rv) / 2, v1 = 1 - v0, eu = Math.min(0.04, D / W) * ru, ev = Math.min(0.04, D / H) * rv;
      var faces = [[u1 - eu, v0, u1, v1], [u0, v0, u0 + eu, v1], [u0, v1 - ev, u1, v1], [u0, v0, u1, v0 + ev], [u0, v0, u1, v1], [u0, v0, u1, v1]];
      for (var f = 0; f < 6; f++) { var r = faces[f], b = f * 4; uv.setXY(b, r[0], r[3]); uv.setXY(b + 1, r[2], r[3]); uv.setXY(b + 2, r[0], r[1]); uv.setXY(b + 3, r[2], r[1]); }
      uv.needsUpdate = true;
      var front = new T.MeshStandardMaterial({ map: tex, roughness: 0.85, metalness: 0 });
      var side = new T.MeshStandardMaterial({ map: tex, roughness: 0.9, metalness: 0, color: new T.Color('#e4ded4') });
      var back = new T.MeshStandardMaterial({ color: new T.Color('#e8dfcf'), roughness: 1, metalness: 0 });
      var mesh = c.tri ? triGroup(T, c, front, side, back) : new T.Mesh(geo, [side, side, side, side, front, back]);
      var scene = new T.Scene(); scene.add(mesh);
      return new Promise(function (res, rej) {
        new T.GLTFExporter().parse(scene, function (buf) {
          if (glbCache.url) URL.revokeObjectURL(glbCache.url);
          glbCache = { key: key, url: URL.createObjectURL(new Blob([buf], { type: 'model/gltf-binary' })) };
          geo.dispose(); tex.dispose();
          res(glbCache.url);
        }, { binary: true, maxTextureSize: max });
      });
    });
  }

  // ---------- USDZ voor iPhone (AR Quick Look), zonder 3D-weergave in de pagina
  var J = 'https://cdn.jsdelivr.net/npm/';
  var usdzCache = { key: null, url: null };
  // Shopify's minifier herschrijft dynamische imports, daarom via een Function
  var dynImp = new Function('u', 'return im' + 'port(u)');
  function buildUSDZ(c) {
    var key = ckey(c);
    if (usdzCache.key === key) return Promise.resolve(usdzCache.url);
    return Promise.all([
      dynImp('https://esm.sh/three@0.160.0'),
      dynImp('https://esm.sh/three@0.160.0/examples/jsm/exporters/USDZExporter.js?deps=three@0.160.0'),
      loadImg(c.url)
    ]).then(function (r) {
      var T = r[0], USDZExporter = r[1].USDZExporter, img = r[2];
      var max = 1024, sc = Math.min(1, max / Math.max(img.width, img.height));
      var cv = document.createElement('canvas'); cv.width = Math.round(img.width * sc); cv.height = Math.round(img.height * sc);
      cv.getContext('2d').drawImage(img, 0, 0, cv.width, cv.height);
      var tex = new T.CanvasTexture(cv); tex.colorSpace = T.SRGBColorSpace;
      var W = c.w / 100, H = c.h / 100, D = (c.d || 2) / 100;
      var iar = cv.width / cv.height, car = W / H, ru = 1, rv = 1;
      if (iar > car) ru = car / iar; else if (iar < car) rv = iar / car;
      var u0 = (1 - ru) / 2, u1 = 1 - u0, v0 = (1 - rv) / 2, v1 = 1 - v0, eu = Math.min(0.04, D / W) * ru, ev = Math.min(0.04, D / H) * rv;
      var front = new T.MeshStandardMaterial({ map: tex, roughness: 0.85, metalness: 0 });
      var side = new T.MeshStandardMaterial({ map: tex, roughness: 0.9, metalness: 0, color: 0xe4ded4 });
      var back = new T.MeshStandardMaterial({ color: 0xe8dfcf, roughness: 1, metalness: 0 });
      var g = new T.Group();
      function plane(pw, ph, rect, m, pos, rx, ry) {
        var geo = new T.PlaneGeometry(pw, ph), uv = geo.attributes.uv;
        for (var i = 0; i < uv.count; i++) uv.setXY(i, rect[0] + uv.getX(i) * (rect[2] - rect[0]), rect[1] + uv.getY(i) * (rect[3] - rect[1]));
        var me = new T.Mesh(geo, m); me.position.set(pos[0], pos[1], pos[2]); me.rotation.set(rx || 0, ry || 0, 0); g.add(me);
      }
      if (c.tri) { g = triGroup(T, c, front, side, back); } else {
      plane(W, H, [u0, v0, u1, v1], front, [0, 0, D]);
      plane(W, H, [0, 0, 1, 1], back, [0, 0, 0], 0, Math.PI);
      plane(D, H, [u1, v0, u1 - eu, v1], side, [W / 2, 0, D / 2], 0, Math.PI / 2);
      plane(D, H, [u0 + eu, v0, u0, v1], side, [-W / 2, 0, D / 2], 0, -Math.PI / 2);
      plane(W, D, [u0, v1, u1, v1 - ev], side, [0, H / 2, D / 2], -Math.PI / 2, 0);
      plane(W, D, [u0, v0, u1, v0 + ev], side, [0, -H / 2, D / 2], Math.PI / 2, 0);
      }
      var scene = new T.Scene(); scene.add(g);
      return new USDZExporter().parse(scene, { ar: { anchoring: { type: 'plane' }, planeAnchoring: { alignment: 'vertical' } }, quickLookCompatible: true, maxTextureSize: 1024 }).then(function (buf) {
        g.traverse(function (o) { if (o.geometry) o.geometry.dispose(); }); tex.dispose();
        if (usdzCache.url) URL.revokeObjectURL(usdzCache.url);
        usdzCache = { key: key, url: URL.createObjectURL(new Blob([buf], { type: 'model/vnd.usdz+zip' })) };
        return usdzCache.url;
      });
    });
  }

  // ---------- stijl
  var css = '' +
  '.ewl{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;background:rgba(10,34,57,.42);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);opacity:0;transition:opacity .35s ease;font-family:inherit;color:#0a2239;}' +
  '.ewl.on{opacity:1}' +
  '@media(min-width:760px){.ewl{align-items:center}}' +
  '.ewl-card{position:relative;width:100%;max-width:560px;max-height:94vh;overflow:auto;background:#FCFBF8;border-radius:24px 24px 0 0;padding:22px 20px 24px;transform:translateY(100%);transition:transform .5s cubic-bezier(.32,.72,0,1);will-change:transform;box-shadow:0 30px 60px -20px rgba(10,34,57,.45);}' +
  '.ewl.on .ewl-card{transform:none}' +
  '@media(min-width:760px){.ewl-card{border-radius:24px;padding:26px 26px 28px;transform:translateY(18px) scale(.97);opacity:0;transition:transform .45s cubic-bezier(.22,1,.36,1),opacity .3s ease}.ewl.on .ewl-card{opacity:1}}' +
  '@media(prefers-reduced-motion:reduce){.ewl-card{transition:none!important}}' +
  '.ewl-x{position:absolute;right:14px;top:14px;width:38px;height:38px;border-radius:50%;border:0;background:#F2EFE9;color:#0a2239;display:grid;place-items:center;cursor:pointer}' +
  '.ewl-h{font-family:var(--font-heading-family,Georgia,serif);font-size:24px;font-weight:600;letter-spacing:-.01em;margin:2px 48px 4px 0;line-height:1.15}' +
  '.ewl-sub{font-size:14px;color:#5d6b7a;margin:0 0 16px}' +
  '.ewl-tabs{display:flex;gap:4px;padding:4px;background:#F2EFE9;border-radius:100px;margin-bottom:16px}' +
  '.ewl-tab{flex:1;border:0;background:transparent;padding:10px 8px;border-radius:100px;font:inherit;font-size:14px;font-weight:600;color:#5d6b7a;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:7px;transition:background .2s,color .2s}' +
  '.ewl-tab.on{background:#fff;color:#0a2239;box-shadow:0 2px 8px -3px rgba(10,34,57,.25)}' +
  '.ewl [hidden]{display:none !important}' +
  '.ewl-pane{display:none}.ewl-pane.on{display:block}' +
  '.ewl-mv{position:relative;height:300px;border-radius:18px;overflow:hidden;background:linear-gradient(180deg,#efe9df,#e4dbcd)}' +
  '.ewl-mv model-viewer{width:100%;height:100%;--poster-color:transparent}' +
  '.ewl-load{position:absolute;inset:0;display:grid;place-items:center;font-size:13.5px;color:#5d6b7a}' +
  '.ewl-spin{width:26px;height:26px;border-radius:50%;border:2.5px solid rgba(10,34,57,.15);border-top-color:#b87333;animation:ewlS .8s linear infinite;margin:0 auto 10px}' +
  '@keyframes ewlS{to{transform:rotate(360deg)}}' +
  '.ewl-btn{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;margin-top:14px;padding:16px 20px;border:0;border-radius:100px;background:#0a2239;color:#F2EFE9;font:inherit;font-size:15.5px;font-weight:700;cursor:pointer;box-shadow:0 14px 26px -12px rgba(10,34,57,.5)}' +
  '.ewl-btn[disabled],.ewl-btn.off{opacity:.45;cursor:default;pointer-events:none}' +
  'a.ewl-btn{text-decoration:none}a.ewl-btn img{display:none}' +
  '.ewl-still{position:absolute;inset:0;display:grid;place-items:center;perspective:900px}' +
  '.ewl-still i{display:block;width:62%;max-height:70%;background-size:cover;background-position:center;border-radius:2px;transform:rotateY(-14deg) rotateX(4deg);box-shadow:18px 24px 40px -16px rgba(10,34,57,.55),inset -6px 0 0 rgba(0,0,0,.12)}' +
  '.ewl-btn.ghost{background:transparent;color:#0a2239;border:1px solid rgba(10,34,57,.2);box-shadow:none;font-weight:600}' +
  '.ewl-note{font-size:13px;line-height:1.5;color:#5d6b7a;margin:12px 2px 0;text-align:center}' +
  '.ewl-note b{color:#0a2239}' +
  '.ewl-drop{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;height:260px;border:1.5px dashed rgba(184,115,51,.5);border-radius:18px;background:#F7F3EC;cursor:pointer;text-align:center;padding:20px;color:#5d6b7a;font-size:14px}' +
  '.ewl-drop b{color:#0a2239;font-size:15.5px}' +
  '.ewl-drop i{width:52px;height:52px;border-radius:50%;background:#0a2239;color:#fff;display:grid;place-items:center}' +
  '.ewl-stage{position:relative;border-radius:18px;overflow:hidden;background:#222;touch-action:none;user-select:none;-webkit-user-select:none}' +
  '.ewl-stage>img{display:block;width:100%;height:auto;max-height:62vh;object-fit:contain;pointer-events:none}' +
  '.ewl-art{position:absolute;left:0;top:0;cursor:grab;background-size:cover;background-position:center;box-shadow:6px 12px 22px -6px rgba(0,0,0,.5),0 2px 4px rgba(0,0,0,.25);border-radius:1px;touch-action:none}' +
  '.ewl-art:active{cursor:grabbing}' +
  '.ewl-art::after{content:"";position:absolute;top:0;bottom:0;left:100%;width:var(--ewl-d,4px);background:linear-gradient(90deg,rgba(0,0,0,.28),rgba(0,0,0,.12));transform:skewY(30deg);transform-origin:left top}' +
  '.ewl-art.tri{background:none!important;box-shadow:none}.ewl-art.tri::after{display:none}' +
  '.ewl-tp{display:block!important;position:absolute;top:0;bottom:0;background-repeat:no-repeat;box-shadow:6px 12px 22px -6px rgba(0,0,0,.5),0 2px 4px rgba(0,0,0,.25);border-radius:1px}' +
  '.ewl-tp::after{content:"";position:absolute;top:0;bottom:0;left:100%;width:var(--ewl-d,4px);background:linear-gradient(90deg,rgba(0,0,0,.28),rgba(0,0,0,.12));transform:skewY(30deg);transform-origin:left top}' +
  '.ewl-tag{position:absolute;left:50%;top:100%;transform:translate(-50%,8px);white-space:nowrap;font-size:11.5px;font-weight:600;background:rgba(255,255,255,.92);color:#0a2239;padding:3px 9px;border-radius:100px;pointer-events:none}' +
  '.ewl-ctrl{margin-top:14px}' +
  '.ewl-ctrl label{display:flex;justify-content:space-between;font-size:13.5px;font-weight:600;margin-bottom:8px}' +
  '.ewl-ctrl label span{color:#b87333}' +
  '.ewl-ctrl input[type=range]{width:100%;accent-color:#0a2239}' +
  '.ewl-row{display:flex;gap:10px}.ewl-row .ewl-btn{margin-top:12px}';

  var root, els = {}, cur = null, arOk = null, wall = { src: null, cm: 300, x: 0.5, y: 0.42 };

  function h(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var ICON_CAM = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h2.2l1.6-2h7.4l1.6 2h2.2A1.5 1.5 0 0 1 21 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 17.5z"/><circle cx="12" cy="12.5" r="3.5"/></svg>';
  var ICON_IMG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M21 16l-5-5-9 9"/></svg>';

  function build() {
    if (root) return;
    var st = h('style'); st.textContent = css; document.head.appendChild(st);
    root = h('div', 'ewl'); root.style.display = 'none'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Bekijk aan je eigen muur');
    root.innerHTML = '<div class="ewl-card">' +
      '<button type="button" class="ewl-x" aria-label="Sluiten"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<h2 class="ewl-h">Bekijk aan je eigen muur</h2><p class="ewl-sub"></p>' +
      '<div class="ewl-tabs" role="tablist"><button type="button" class="ewl-tab" data-t="cam">' + ICON_CAM + 'Met je camera</button><button type="button" class="ewl-tab" data-t="photo">' + ICON_IMG + 'Met een foto</button></div>' +
      '<div class="ewl-pane" data-p="cam"><div class="ewl-mv"><div class="ewl-load"><div><div class="ewl-spin"></div>Je canvas wordt klaargezet…</div></div></div>' +
        '<button type="button" class="ewl-btn ewl-ar" disabled>' + ICON_CAM + 'Open camera</button><a class="ewl-btn ewl-ql off" rel="ar" href="#" hidden><img alt="" src="data:image/gif;base64,R0lGODlhAQABAAAAACw=">' + ICON_CAM + '<span>Open camera</span></a><p class="ewl-note ewl-arnote"></p></div>' +
      '<div class="ewl-pane" data-p="photo"><label class="ewl-drop"><i>' + ICON_IMG + '</i><b>Kies of maak een foto van je muur</b><span>Fotografeer je muur zo recht mogelijk van voren.</span><input type="file" accept="image/*" hidden></label>' +
        '<div class="ewl-wall" hidden><div class="ewl-stage"><img alt="Jouw muur"><div class="ewl-art" role="img" aria-label="Je canvas"><span class="ewl-tag"></span></div></div>' +
        '<div class="ewl-ctrl"><label>Hoe breed is de muur op je foto? <span class="ewl-cm"></span></label><input type="range" min="80" max="800" step="10" class="ewl-range" aria-label="Breedte van de muur op de foto in centimeters"></div>' +
        '<p class="ewl-note">Sleep het canvas naar de juiste plek. Klopt de breedte van je muur, dan klopt ook het formaat.</p>' +
        '<div class="ewl-row"><button type="button" class="ewl-btn ghost ewl-new">Andere foto</button></div></div></div>' +
      '</div>';
    document.body.appendChild(root);
    els.card = root.querySelector('.ewl-card'); els.sub = root.querySelector('.ewl-sub');
    els.tabs = [].slice.call(root.querySelectorAll('.ewl-tab')); els.panes = [].slice.call(root.querySelectorAll('.ewl-pane'));
    els.mv = root.querySelector('.ewl-mv'); els.ql = root.querySelector('.ewl-ql'); els.ar = root.querySelector('.ewl-ar'); els.arnote = root.querySelector('.ewl-arnote');
    els.drop = root.querySelector('.ewl-drop'); els.file = root.querySelector('.ewl-drop input'); els.wall = root.querySelector('.ewl-wall');
    els.stage = root.querySelector('.ewl-stage'); els.img = root.querySelector('.ewl-stage img'); els.art = root.querySelector('.ewl-art'); els.tag = root.querySelector('.ewl-tag');
    els.range = root.querySelector('.ewl-range'); els.cm = root.querySelector('.ewl-cm');
    root.querySelector('.ewl-x').addEventListener('click', close);
    root.addEventListener('click', function (e) { if (e.target === root) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });
    els.tabs.forEach(function (t) { t.addEventListener('click', function () { tab(t.dataset.t); }); });
    els.file.addEventListener('change', function () { var f = els.file.files && els.file.files[0]; if (f) setWall(f); els.file.value = ''; });
    root.querySelector('.ewl-new').addEventListener('click', function () { els.file.click(); });
    els.range.addEventListener('input', function () { wall.cm = +els.range.value; layout(); });
    els.ar.addEventListener('click', function () {
      var m = els.mv.querySelector('model-viewer'); if (!m || !m.canActivateAR) return;
      m.activateAR();
      // zodra de camera open is: de 3D-weergave weggooien en het venster sluiten. Bij terugkomen sta je weer gewoon in de configurator.
      var done = false;
      function rel() { if (done) return; done = true; window.removeEventListener('blur', rel); document.removeEventListener('visibilitychange', vis); setTimeout(function () { releaseMV(); close(); }, 300); }
      function vis() { if (document.hidden) rel(); }
      window.addEventListener('blur', rel); document.addEventListener('visibilitychange', vis);
      setTimeout(rel, 12000);
    });
    drag();
    window.addEventListener('resize', function () { if (root.classList.contains('on')) layout(); });
  }

  function tab(t) {
    els.tabs.forEach(function (b) { var on = b.dataset.t === t; b.classList.toggle('on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    els.panes.forEach(function (p) { p.classList.toggle('on', p.dataset.p === t); });
    if (t === 'cam') prepAR();
    if (t === 'photo') layout();
  }

  // ---------- camera / AR
  function prepAR() {
    if (!cur) return;
    var mvEl = els.mv.querySelector('model-viewer');
    if (mvEl && mvEl.dataset.key === cur.key) return;
    els.ar.disabled = true;
    els.mv.innerHTML = '<div class="ewl-load"><div><div class="ewl-spin"></div>Je canvas wordt klaargezet…</div></div>';
    var key = cur.key;
    Promise.all([load(MV, true), buildGLB(cur)]).then(function (r) {
      if (!cur || cur.key !== key) return;
      return customElements.whenDefined('model-viewer').then(function () {
        var m = document.createElement('model-viewer');
        m.dataset.key = key;
        m.setAttribute('src', r[1]);
        m.setAttribute('alt', 'Je canvas van ' + cur.w + ' × ' + cur.h + ' cm');
        m.setAttribute('ar', ''); m.setAttribute('ar-modes', 'webxr quick-look'); m.setAttribute('ar-placement', 'wall'); m.setAttribute('ar-scale', 'fixed');
        m.setAttribute('camera-controls', ''); m.setAttribute('touch-action', 'pan-y'); m.setAttribute('shadow-intensity', '0.8'); m.setAttribute('exposure', '1.05');
        m.setAttribute('environment-image', 'neutral'); m.setAttribute('camera-orbit', '-18deg 82deg auto'); m.setAttribute('interaction-prompt', 'none');
        var hide = h('span'); hide.slot = 'ar-button'; hide.style.display = 'none'; m.appendChild(hide);
        m.addEventListener('load', function () {
          var ld = els.mv.querySelector('.ewl-load'); if (ld) ld.remove();
          setTimeout(function () { arState(m); }, 300);
        });
        m.addEventListener('ar-status', function (e) { if (e.detail && e.detail.status === 'failed') { els.arnote.innerHTML = 'De camera kon niet starten. Probeer het nog eens, of gebruik <b>Met een foto</b>.'; } });
        els.mv.appendChild(m);
      });
    }).catch(function () {
      els.mv.innerHTML = '<div class="ewl-load"><div>Het 3D-model kon niet geladen worden.</div></div>';
      els.arnote.innerHTML = 'Gebruik in plaats daarvan <b>Met een foto</b>.';
    });
  }
  function prepQL() {
    if (els.ql.dataset.key === cur.key) return;
    var key = cur.key;
    els.ar.hidden = true; els.ql.hidden = false; els.ql.classList.add('off'); els.ql.querySelector('span').textContent = 'Camera wordt klaargezet…';
    els.mv.innerHTML = '<div class="ewl-still"><i></i></div>';
    var still = els.mv.querySelector('.ewl-still i'); still.style.backgroundImage = 'url("' + cur.url + '")'; still.style.aspectRatio = cur.w + '/' + cur.h;
    els.arnote.innerHTML = 'Je canvas verschijnt op ware grootte aan je muur: <b>' + cur.w + ' × ' + cur.h + ' cm</b>.';
    buildUSDZ(cur).then(function (url) {
      if (!cur || cur.key !== key) return;
      els.ql.dataset.key = key;
      els.ql.href = url + '#allowsContentScaling=0';
      els.ql.classList.remove('off'); els.ql.querySelector('span').textContent = 'Open camera';
      els.arnote.innerHTML = 'Tik op <b>Open camera</b>, richt je telefoon op je muur en beweeg hem even rustig heen en weer. Je canvas verschijnt op ware grootte: <b>' + cur.w + ' × ' + cur.h + ' cm</b>.';
    }).catch(function () {
      els.ql.querySelector('span').textContent = 'Camera niet beschikbaar';
      els.arnote.innerHTML = 'Het lukte niet om de camera klaar te zetten. Gebruik <b>Met een foto</b>.';
    });
  }
  function releaseMV() {
    var m = els.mv && els.mv.querySelector('model-viewer');
    if (m) { try { m.removeAttribute('src'); } catch (e) {} m.remove(); }
    if (els.mv) els.mv.innerHTML = '<div class="ewl-load"><div><div class="ewl-spin"></div>Je canvas wordt klaargezet…</div></div>';
    if (els.ar) els.ar.disabled = true;
  }
  function arState(m) {
    var ok = !!m.canActivateAR;
    els.ar.disabled = !ok;
    els.ar.hidden = !ok;
    els.arnote.innerHTML = ok
      ? 'Richt je camera op je muur en tik op het oppervlak. Je canvas verschijnt op ware grootte: <b>' + cur.w + ' × ' + cur.h + ' cm</b>.'
      : 'Aan je muur hangen met de camera werkt op een <b>iPhone of Android-telefoon</b>. Hier kun je je canvas rond draaien, of je gebruikt <b>Met een foto</b>.';
  }

  // ---------- muurfoto
  function setWall(file) {
    if (wall.src) URL.revokeObjectURL(wall.src);
    wall.src = URL.createObjectURL(file); wall.x = 0.5; wall.y = 0.42;
    els.img.onload = function () { els.drop.hidden = true; els.wall.hidden = false; layout(); };
    els.img.src = wall.src;
  }
  function layout() {
    if (!cur) return;
    els.range.value = wall.cm; els.cm.textContent = wall.cm + ' cm';
    if (els.wall.hidden || !els.img.naturalWidth) return;
    var W = els.stage.clientWidth, H = els.stage.clientHeight;
    var aw = Math.max(16, W * cur.w / wall.cm), ah = aw * cur.h / cur.w;
    if (ah > H * 0.95) { ah = H * 0.95; aw = ah * cur.w / cur.h; }
    var x = Math.max(0, Math.min(W - aw, wall.x * W - aw / 2)), y = Math.max(0, Math.min(H - ah, wall.y * H - ah / 2));
    var a = els.art.style; a.width = aw + 'px'; a.height = ah + 'px'; a.transform = 'translate(' + x + 'px,' + y + 'px)';
    a.setProperty('--ewl-d', Math.max(2, aw * (cur.d || 2) / cur.w * 0.7) + 'px');
    els.art.classList.toggle('tri', !!cur.tri);
    [].slice.call(els.art.querySelectorAll('.ewl-tp')).forEach(function (n) { n.remove(); });
    if (cur.tri) {
      a.backgroundImage = 'none';
      var t = cur.tri, dd = cur.d || 2, k = aw / cur.w, TTp = (cur.w + 2 * dd) * k, THp = (cur.h + 2 * dd) * k, tph = t.ph || cur.h, tc = t.cols || 3, tr = t.rows || 1;
      for (var n = 0; n < tc * tr; n++) {
        var p = document.createElement('div'), x0 = (n % tc) * (t.pw + t.gap), y0 = Math.floor(n / tc) * (tph + t.gap); p.className = 'ewl-tp';
        p.style.cssText = 'left:' + (x0 * k) + 'px;width:' + (t.pw * k) + 'px;top:' + (y0 * k) + 'px;height:' + (tph * k) + 'px;bottom:auto;background-image:url("' + cur.url + '");background-size:' + TTp + 'px ' + THp + 'px;background-position:' + (-(dd + x0) * k) + 'px ' + (-(dd + y0) * k) + 'px';
        els.art.insertBefore(p, els.tag);
      }
      els.tag.textContent = (t.n || 3) + ' × ' + t.pw + ' × ' + tph + ' cm';
    } else {
      a.backgroundImage = 'url("' + cur.url + '")';
      els.tag.textContent = cur.w + ' × ' + cur.h + ' cm';
    }
  }
  function drag() {
    var on = false, sx, sy, ox, oy;
    els.art.addEventListener('pointerdown', function (e) {
      on = true; sx = e.clientX; sy = e.clientY; ox = wall.x; oy = wall.y;
      try { els.art.setPointerCapture(e.pointerId); } catch (x) {}
      e.preventDefault();
    });
    els.art.addEventListener('pointermove', function (e) {
      if (!on) return;
      var W = els.stage.clientWidth, H = els.stage.clientHeight;
      wall.x = Math.max(0, Math.min(1, ox + (e.clientX - sx) / W)); wall.y = Math.max(0, Math.min(1, oy + (e.clientY - sy) / H));
      layout();
    });
    function up() { on = false; }
    els.art.addEventListener('pointerup', up); els.art.addEventListener('pointercancel', up);
  }

  // ---------- openen / sluiten
  var lastFocus = null;
  function open(c) {
    if (!c || !c.url) return;
    build();
    cur = { url: c.url, w: c.w, h: c.h, d: c.d || 2, tri: c.tri || null }; cur.key = ckey(cur);
    els.sub.textContent = cur.tri ? 'Je ' + String(cur.tri.name || 'drieluik').toLowerCase() + ' van ' + (cur.tri.n || 3) + ' × ' + cur.tri.pw + ' × ' + (cur.tri.ph || cur.h) + ' cm (' + cur.w + ' × ' + cur.h + ' cm totaal), op ware grootte.' : 'Je canvas van ' + cur.w + ' × ' + cur.h + ' cm, op ware grootte.';
    lastFocus = document.activeElement;
    root.style.display = 'flex';
    void root.offsetHeight;
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('on'); }); });
    document.documentElement.style.overflow = 'hidden';
    var mobile = window.matchMedia('(pointer: coarse)').matches;
    tab(mobile ? 'cam' : 'photo');
    arCheck().then(function (ok) { arOk = ok; if (!ok && mobile) tab('photo'); });
    setTimeout(function () { try { root.querySelector('.ewl-x').focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function close() {
    if (!root) return;
    if (window.matchMedia('(pointer: coarse)').matches) setTimeout(releaseMV, 500);
    root.classList.remove('on');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!root.classList.contains('on')) root.style.display = 'none'; }, 480);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  window.ElaramoWall = { open: open, close: close, _usdz: buildUSDZ };
})();
